import { COOKIE_AUTH_NAME, COOKIE_PASSWORD_TOKEN_NAME, COOKIE_REFRESH_TOKEN_NAME } from "../constants";

/** @returns {string}  */
function getAllCookies() {
  const cookieList = document.cookie.split(";");
  const cookies = {};

  for (const cookie of cookieList) {
    const [name, value] = cookie.split("=");

    if (!name || !value) {
      return;
    }

    cookies[name.trim()] = value;
  }

  return cookies;
}

/**
 * @param {`authorization`} name
 * @returns {string}
 */
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
}

/**
 * @param {string} name
 * @param {string} value
 * @param {{expires: number}?} options
 * @returns {string}
 */
function setCookie(name, value, options) {
  let expires = options?.expires;

  if (typeof expires === "number" && expires) {
    const date = new Date();
    date.setTime(date.getTime() + expires * 1000);
    expires = options.expires = date;
  }
  if (expires && expires.toUTCString) {
    options.expires = expires.toUTCString();
  }

  value = encodeURIComponent(value);

  let updatedCookie = `${name}=${value}`;

  for (const propName in options) {
    updatedCookie += `; ${propName}`;
    const propValue = options[propName];
    if (propValue !== true) {
      updatedCookie += `=${propValue}`;
    }
  }

  document.cookie = updatedCookie;
}

function clearCookies() {
  document.cookie.split(";").forEach((cookie) => setCookie(cookie.split("=")[0], ""));
}

function setCredentialsCookies(response) {
  const passwordName = response.headers.get(COOKIE_PASSWORD_TOKEN_NAME);

  const options = {
    path: "/",
    sameSite: "none",
    secure: "true",
  };

  setCookie(COOKIE_AUTH_NAME, response.headers.get(COOKIE_AUTH_NAME), options);
  setCookie(COOKIE_REFRESH_TOKEN_NAME, response.headers.get(COOKIE_REFRESH_TOKEN_NAME), options);
  setCookie(passwordName, response.headers.get(passwordName), options);
}

export { getAllCookies, getCookie, setCookie, clearCookies, setCredentialsCookies };
